export default "__VITE_ASSET__mmH9jBdY__"